const axios = require('@/utils/axios')
const {baseURL} = require('@/assets/js/config')
const $http = axios.create({
	baseURL
})

const state = {
	subjects : [],
	current_subject : null,
}

const getters = {
	fetchSubjects : (state) => state.subjects,
	fetchCurrentSubject : (state) => state.current_subject,
}

const actions = {
	loadSubjects({commit}, {token}){
		return $http.get(`subject`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_SUBJECTS', response.data)
		})
	},

	loadSubjectDetails({commit}, {subject, token}){
		return $http.get(`subject/${subject}`, {
			headers : {
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_SUBJECT', response.data)
		})
	},

	createSubject({commit}, {subject, token}){
		// let subject_formdata = new FormData()
		// for(let key in subject){
		// 	if(key == 'subjectfiles'){
		// 		for(let i in subject[key]){
		// 			subject_formdata.append(`${key}`, subject[key][i])
		// 		}
		// 	}else{
		// 		subject_formdata.append(key, subject[key])
		// 	}	
		// }
		
		return $http.post('subject', subject, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('ADD_SUBJECT', response.data)
		})
	},

	updateSubject({commit}, {subject_id, subject, token}){
		// let subject_formdata = new FormData()
		// for(let key in subject){
		// 	if(key == 'subjectfiles'){
		// 		for(let i in subject[key]){
		// 			subject_formdata.append(`${key}`, subject[key][i])
		// 		}
		// 	}else if(key == 'editfiles'){
		// 		subject_formdata.append(key, JSON.stringify(subject[key]))
		// 	}else{
		// 		subject_formdata.append(key, subject[key])
		// 	}	
		// }
		
		return $http.put(`subject/${subject_id}`, subject, {
			headers : {
				// 'Content-Type' : 'undefined',
				'x-auth-token' : token
			}
		}).then((response) => {
			commit('SET_CURRENT_SUBJECT', response.data)
		})
	},

	deleteSubject({commit}, {subject, token}){
		return $http.delete(`subject/${subject}`, {
			headers : {
				'x-auth-token' : token
			} 
		}).then(() => {
			commit('REMOVE_SUBJECT', subject)	
		})
	},
}

const mutations = {
	SET_SUBJECTS : (state, subjects) => {
		state.subjects = subjects
	},
	SET_CURRENT_SUBJECT : (state, subject) => {
		state.current_subject = subject
	},
	ADD_SUBJECT : (state, subject) => {
		state.subjects.push(subject)
	},
	REMOVE_SUBJECT : (state, subject_id) => {
		state.subjects = state.subjects.filter(subject => subject._id != subject_id)
	},
}

export default {
	state, getters, actions, mutations
}